import { Component, OnInit } from '@angular/core';
import { MessageBoxComponent } from '@common/popups/message-box/message-box.component';
import { LayoutService } from '@common/services/layout.service';
import { ModalService } from '@common/services/modal.service';
import { NumberInputComponent } from '@common/UI/number-input/number-input.component';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { Filterable } from '@common/utilities/Filterable';
import { commit } from '@core/operators';
import { CurrenciesService } from '@core/services/currencies.service';
import { calculateExportPrice, DataService, ProductRecord } from '@core/services/data.service';
import { ProductsService } from '@core/services/products.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { Multilingual } from '@core/utilities/multilingual';
import { map } from 'rxjs/operators';


interface ProductRecordEx extends ProductRecord {
  Saved: boolean;
  Checked: boolean;
}

@Component({
  selector: 'app-prices',
  templateUrl: './prices.component.html',
  styleUrls: ['./prices.component.scss']
})
export class PricesComponent implements OnInit {

  constructor(
    private ds: DataService,
    private layout: LayoutService,
    private modal: ModalService,
    private sync: SynchronizationService,
    private psrv: ProductsService,

    private currencies: CurrenciesService
  ) { }

  public products = new Filterable<ProductRecordEx>();
  public get loading(): boolean {
    return !this.sync.ready(CurrenciesService, ProductsService);
  }

  public synchronize() {

    this.sync.with(ProductsService).repeat(() => this.ds.products('pending').pipe(map(products => products ? commit<boolean>(() => this.products.source = products.map(i => ({ ...i, Saved: true, Checked: i.IsPriceVerified }))).return(true) : false)));

    this.sync.when(CurrenciesService, ProductsService).commit(() => {

      if (this.products.empty) this.modal.show(MessageBoxComponent, {
        ignoreBackdropClick: false, state: {
          closable: true,
          message: Multilingual.getText("Hiện tại không có mặt hàng cần kiểm tra giá. Xin vui lòng quay lại sau!"),
          title: Multilingual.getText("Thông báo"),
        }
      });

    });
  }

  ngOnInit(): void {
    this.layout.title = Multilingual.getText("Chốt giá nhập xưởng");
    this.synchronize();
  }

  public savable(product: ProductRecordEx): boolean {
    return !product.Saved && product.UnitPrice > 0 && product.LogisticsMargin > 0 && product.ProfitMargin > 0;
  }

  public checkable(product: ProductRecordEx): boolean {
    return product.Saved && !product.Checked;
  }

  public price(product: ProductRecord): number {
    return calculateExportPrice(product, this.currencies.get("CNY"), this.currencies.get("VND"), 0);
  }

  public update(input: NumberInputComponent, product: ProductRecordEx, field: string) {

    if (isNaN(input.value)) input.value = 0;

    switch (field) {
      case 'ProfitMargin': product[field] = input.value / 100; break;
      default: product[field] = input.value;
    }

    product.Saved = false;    
  }

  public extractor(field: string): SortableExtractor<ProductRecordEx> {
    return {
      extract: i => i[field]
    }
  }

  public save(product: ProductRecordEx) {
    this.ds.products("update", product).subscribe(results => {
      product.Saved = results && results.length == 1;
      product.Checked = product.Checked || product.Saved;

      if (product.Saved) this.psrv.synchronize();
    });
  }
}
